import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "weekdays-list" }

import router from '@/router';
import { onMounted, reactive } from 'vue';
import { GetModifiedScheduleSubpageResponseModel } from './ModifiedScheduleSubpage.types';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import { getModifiedTeacherClassScheduleSubpageByClassId } from './apiMethods';
import { findScheduleParam } from '@/helpers/findScheduleParam';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModifiedScheduleSubpage',
  setup(__props) {

const state = reactive<{ data: GetModifiedScheduleSubpageResponseModel }>({
    data: {
        todayMSEForClass: { mseList: [], version: '' },
        todayScheduleParams: {
            todayScheduleParams: [],
        },
    },
});

onMounted(() => {
    const classId = router.currentRoute.value.params.classId;

    getModifiedTeacherClassScheduleSubpageByClassId(classId).then((res) => {
        state.data = res.data;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.todayMSEForClass.mseList, (day) => {
      return (_openBlock(), _createBlock(UniversalCard, {
        class: _normalizeClass(day.colorSchemeName),
        props: {
                type: 'elevated-secondary',
                icon: `${_unref(getBaseUrl)()}${day.iconURL}`,
                title: `${day.num}. ${day.subjectFullName}`,
                content:  day.comments as string | undefined,
                buttons: [
                    {
                        iconName: 'edit',
                        innerText: 'Изменить',
                        size: 'full',
                        type: 'filled',
                        redirectToOnClick: `/teacher/schedule/modify/${day.mseUuid}?version=${day.thisMseVersion}&returnTo=sn.teacher.class.modifiedSchedule`,
                    },
                ],
                dataTags: [
                    {
                        color: 'var(--snotra--sys--surface)', 
                        title: `${
                            _unref(findScheduleParam)(
                                state.data.todayScheduleParams
                                    .todayScheduleParams,
                                day.num
                            ).begin
                        } - ${
                            _unref(findScheduleParam)(
                                state.data.todayScheduleParams
                                    .todayScheduleParams,
                                day.num
                            ).end
                        } (${
                            _unref(findScheduleParam)(
                                state.data.todayScheduleParams
                                    .todayScheduleParams,
                                day.num
                            ).durationInMins
                        } мин.)`,
                        iconLocal: 'time.png',
                    },
                    {
                        color: 'var(--snotra--sys--surface)', 
                        title: day.location,
                        iconLocal: 'school.png',
                    },
                    {
                        color: 'var(--snotra--sys--surface)', 
                        title: day.groupName ? day.groupName : 'Весь класс',
                        iconLocal: 'student.png',
                    },
                    {
                        color: 'var(--snotra--sys--surface)', 
                        title: `Перемена после: ${
                            _unref(findScheduleParam)(
                                state.data.todayScheduleParams
                                    .todayScheduleParams,
                                day.num
                            ).breakDurationInMins
                        } минут`,
                        iconLocal: 'bell.png',
                    },
                ],
            },
        key: day.mseUuid
      }, null, 8, ["class", "props"]))
    }), 128))
  ]))
}
}

})